import { useState, useRef } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getLandingPageUrl } from "../ClientProfile/LandingPageSelector";
import {
  getClientDefaultLandingPage,
  hasAccessToNetwork,
} from "../../services/accountService";

import { isClient, isLoggedIn } from "../../services/accountService";

import { pages } from "../../constants";

function RedirectOnLogging() {
  const history = useHistory();
  const isLandingPageMountedRef = useRef(true);

  const [loginLandingPageURL, setLoginLandingPageURL] = useState();

  const isClientLogin = isClient() && isLoggedIn();

  const { isInitialLoading: isQueryLoadingOnLogin } = useQuery({
    queryKey: ["default-landing-page"],
    queryFn: getClientDefaultLandingPage,
    enabled: isClientLogin && hasAccessToNetwork(),
    onSuccess: (response) => {
      const landingPage = response?.data?.homePage
        ? getLandingPageUrl(response.data?.homePage)
        : pages.mainPage.url;

      setLoginLandingPageURL(landingPage);
      history.push(landingPage);
    },
  });

  if (!hasAccessToNetwork()) {
    return <Redirect to={pages.orderHistory.url} />;
  }

  return (
    <>
      {loginLandingPageURL &&
        isLandingPageMountedRef.current &&
        isQueryLoadingOnLogin && <Redirect to={loginLandingPageURL} />}

      {!isClientLogin && <Redirect to={pages.orderHistory.url} />}
    </>
  );
}

export default RedirectOnLogging;
